/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![TwitterNeutralIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABwElEQVR4nO1VPWgUURB+CYJCDNFYCNqEFGlDCgst3OrgZHd+Tng7c4myBgSxlXSCW4pgY20R7WySQkQtJCAkpSEQkiIkkHQJkp9SPBLlRU28u/3lrswHA8vuzDfzvpmdZ8wZiiKO496ivsz3ryDLS2BdQZINJP0YsNz59x1RxxD1WlMQks4EtfBGHrl/d3wYWbeQ9VeLHQHrOyT9BqwLxpiek6BqtXoeWRvAsh9w/WZWAmT9kkB+aiSbwPIYWKOTIGvtxf+cGkD63IuiC23V+/Z6JvlfA5ZFa+1gi0Sy1uREuh6QTAHo1VNtw9u5CUjWXMFtRyeqP0wJaiDpPLC8BpJXBar/3EZeqdzrI6o/Apb3RSTA7BO8SWwekO52TM7O5FnKdMiLbiQgklvJCRD7gfVrh9V/9zzvXGKCP42OLiHLU2TZ66o8pcaQU6aH9MD3xy+bPBQZRUyyWjhhCqIHSB4g6RKQ/CyYYNqUhdtJSLqc/2Pp28zGOlhrB5x+fi0cRQwngXXObccc8h/IGjdtzTQc72+ST0ByWECOIyD5wCwjpWUhkqHjBccyC6SryLINJDvu2b1DlifuPihNfAaTgd8lOPcVnL1TXgAAAABJRU5ErkJggg==)
 */
export const TwitterNeutralIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="m20.75 7.51.01.59c0 5.96-4.54 12.84-12.84 12.84-2.45 0-4.86-.7-6.92-2.03a9.06 9.06 0 0 0 6.68-1.87 4.52 4.52 0 0 1-4.22-3.13c.68.13 1.38.1 2.04-.08A4.51 4.51 0 0 1 1.88 9.4v-.05c.63.35 1.33.54 2.05.56a4.52 4.52 0 0 1-1.4-6.02 12.81 12.81 0 0 0 9.3 4.71 4.52 4.52 0 0 1 7.7-4.12 9.06 9.06 0 0 0 2.86-1.1 4.53 4.53 0 0 1-1.98 2.5c.9-.1 1.77-.34 2.59-.7-.6.9-1.37 1.7-2.25 2.33Z"
        className={colorClass}
      />
    </svg>
  );
};
